import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FiHeart, FiStar } from 'react-icons/fi';
import loveStoryBg from '../assets/love_story_background_compressed.jpg';
import './StorySection.css';

const StorySection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const sectionStyle = {
    backgroundImage: `url(${loveStoryBg})`,
    backgroundSize: window.innerWidth <= 768 ? 'auto 100%' : 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: window.innerWidth > 768 ? 'fixed' : 'scroll'
  };

  return (
    <section id="story" className="story-section" ref={ref} style={sectionStyle}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            className="heart-decoration"
            animate={{
              scale: [1, 1.2, 1],
              rotate: [0, 5, -5, 0]
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            <FiHeart />
          </motion.div>
          <h2>Our Love Story</h2>
          <p>A journey of two hearts becoming one</p>
        </motion.div>

        {/* Love Story Content */}
        <motion.div
          className="love-story-content"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <div className="story-text">
            <h3>Our Love Journey 🌸</h3>
            <p>What began as a simple friendship has now blossomed into a beautiful love story that's about to become forever. For the past 10 years, we've shared laughter, distance, patience, and countless memories that have shaped us into who we are today.</p>
            
            <p>We've always been two different souls — like the sun and the moon — one who talks endlessly, filling the silence with stories and laughter, and the other who listens with warmth, care, and understanding. Together, we balanced each other in the most perfect way.</p>
            
            <p>Our journey was never easy — miles separated us, but love always kept us close. Through long-distance calls, endless messages, and unspoken trust, we built a bond that distance could never weaken.</p>
            
            <p>With the blessings, love, and prayers of those who stood by us, our story that began with friendship and grew into love is now turning into a lifetime promise — a wedding that celebrates not just our love, but our strength, patience, and faith in each other.</p>
            
            <p>Here's to our forever — to love that endured, to friendship that never faded, and to a journey that continues beautifully as husband and wife. 💍❤️</p>
          </div>
        </motion.div>

        <motion.div
          className="story-footer"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 1.5 }}
        >
          <div className="quote-container">
            <motion.div
              className="quote-icon"
              animate={{ rotate: [0, 5, -5, 0] }}
              transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            >
              <FiStar />
            </motion.div>
            <blockquote>
              "In all the world, there is no heart for me like yours. In all the world, there is no love for you like mine."
            </blockquote>
            <cite>- Maya Angelou</cite>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default StorySection;
